import React, { ReactNode } from 'react';
import Callout from './Callout';

export default function Header({ children }: { children?: ReactNode | ReactNode[] }) {
    return (
        <Callout
            style={{
                textDecoration: 'underline',
            }}
        >
            {children}
        </Callout>
    );
}
